import { Injectable, Injector } from '@angular/core';
import { SortOption } from '@core';
import { Observable } from 'rxjs';
import { DocListBaseService } from 'src/app/shared-feature/services/_base/doc-list-base.service';

@Injectable()
export class SoListService extends DocListBaseService {
  url = 'api/salesorders/list';
  expandProperties =
    'Customer($select=Code),Currency($select=Code),Agent($select=Code),Term($select=Code)';
  override searchColumns: string[] = [
    'DocCode',
    'Description',
    'Customer/Code',
    'CustomerName',
    'Agent/Code',
    'Term/Code',
  ];
  sortOptions: SortOption[] = [
    { title: 'Date', sort: 'docDate' },
    { title: 'Doc #', sort: 'docCode' },
    { title: 'Customer #', sort: 'Customer/Code' },
    { title: 'Customer Name', sort: 'CustomerName' },
    { title: 'Agent #', sort: 'Agent/Code' },
    { title: 'Term', sort: 'termCode' },
    { title: 'Amount', sort: 'netTotalAmount' },
    { title: 'Ref. No', sort: 'referenceNo' },
  ];

  batchDelete(ids: any[]): Observable<any> {
    return this.http.delete('api/salesorders', null, {
      body: { ids: ids }
    });
  }
  constructor(injector: Injector) {
    super(injector);
  }
}
